import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'analysis-search',
  template: `<div class="search-container">
    <input
      #searchInput
      type="text"
      [placeholder]="placeholder"
      [attr.data-test]="id"
      (keyup.enter)="dispatchSearch($event.target)"
    />
    <button type="button" (click)="dispatchSearch(searchInput)" [attr.data-test]="'btnComponentSearch'"></button>
  </div>`,
  styleUrls: ['./search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent implements OnInit {
  @Input()
  placeholder = '';
  @Input() 
  id?: string;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  dispatchSearch(target: HTMLInputElement) {
    this.router.navigate(['/search'], { queryParams: { query: target.value } });
  }
}
